import { createFileRoute } from '@tanstack/react-router'
import EmpreendimentoEditarPage from '@/pages/empreendimentos/empreendimento-editar'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota para editar um empreendimento específico
// Path completo será /dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar
// Renderizada dentro do <Outlet /> de dashboard.$dashboardId.empreendimentos/$empreendimentoId/route.tsx
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar',
)({
  component: function EmpreendimentoEditarRoute() {
    const { dashboardId, empreendimentoId } = Route.useParams()
    return (
      <RequireModule module={MODULES.EMPREENDIMENTOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.EDIT_IMOB_DATA}>
          <EmpreendimentoEditarPage
            dashboardId={dashboardId}
            empreendimentoId={empreendimentoId}
          />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
